// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"104":"707d17c36bada0a2","207":"b3d4af38fb04277d","735":"4be63a2b82bd420c","803":"0ffbfd567da24767"}[chunkId] + ".js";
};